import {useActivateApiAbTestCallback} from '@aboutyou/feature-flags';
import {useEffect} from 'react';

export const useActivatePreselectedBestCouponABTest = (props?: {
  disabled?: boolean;
}) => {
  const activateApiAbTest = useActivateApiAbTestCallback();

  useEffect(() => {
    if (props?.disabled) {
      return;
    }

    activateApiAbTest('ab_preselect_best_coupon');
  }, [activateApiAbTest, props?.disabled]);
};
